import moment from 'moment';
import { useCallback, useMemo } from 'react';

import Input from '../../../components/Input/Input';

import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const InputField = ({ type, ...props }) => {
  const field = useFieldContext();
  const errors = useFieldErrors();

  const onChange = useCallback(
    (e) => {
      let value = e.target.value;
      if (type === 'number' && !isNaN(Number(value))) {
        value = Number(value);
      }
      field.handleChange(value);
    },
    [field, type],
  );

  const value = useMemo(() => {
    let value = field.state.value;
    if (['date', 'datetime-local'].includes(type) && value) {
      value = moment(value).format(
        type === 'date' ? 'yyyy-MM-DD' : 'yyyy-MM-DDTHH:mm',
      );
    }
    return value;
  }, [field.state.value, type]);

  return (
    <Input
      {...props}
      type={type}
      name={field.name}
      value={value}
      onChange={onChange}
      onBlur={field.handleBlur}
      error={errors}
    />
  );
};

export default InputField;

InputField.propTypes = Input.propTypes;
